import { COUNTIES } from './COUNTIES';
import { PROGRAM_AREAS } from './PROGRAM_AREAS';

import {
	ConditionChangeFTE,
	CountyAssignment,
	FTE
} from '../../domain';

const PRECISION: number = 2;

export const CONDITION_CHANGE_FTE: ConditionChangeFTE[] = ([
	[ 0, .2],
	[ 1, .3],
	[ 2, .5]
] as [number, number][]).map(([pa, fte]) =>
	new ConditionChangeFTE(
		PROGRAM_AREAS[pa],
		new FTE(fte, PRECISION)
	));

export const COUNTY_ASSIGNMENTS: CountyAssignment[] = [
	[0, true,  true, 0.8],
	[1, true, false, 0.2]
].map(([countyIndex, director, hq, fte]) => 
	new CountyAssignment(
		COUNTIES[<number>countyIndex],
		<boolean>director,
		<boolean>hq,
		new FTE(<number>fte, PRECISION)));